import CustomInput from './CustomInput';

export * from './CustomInput';

export default CustomInput;
